import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-navigation-helena',
  templateUrl: './navigation-helena.component.html'
})
export class NavigationHelenaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
